// extracted by mini-css-extract-plugin
module.exports = {"is-invalid":"CompanyAddGeneralLedgerCodeReasonModal_is-invalid__A7qsK"};